"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));
var _constants = require("../../constants");
var _Button = _interopRequireDefault(require("../../Button/Button"));
var ItemContent = function ItemContent(_ref) {
  var item = _ref.item,
    index = _ref.index,
    noNotificationText = _ref.noNotificationText;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--item__left flex margin-right-sm"
  }, item.image && /*#__PURE__*/_react["default"].createElement("div", {
    className: "left margin-right-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatarSize: _constants.AVATAR_SIZES.MEDIUM,
    avatarType: _constants.AVATAR_TYPES.CIRCLE,
    image: item.image,
    notificationText: noNotificationText ? null : index + 1
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left right text-component"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "d8-u-font-size-base d8-u-ls-sm"
  }, item.title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm d8-u-color-contrast-medium"
  }, item.subtitle))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--item__right text-right text-component flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "d8-u-font-size-base d8-u-ls-sm"
  }, item.value), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm d8-u-color-contrast-medium"
  }, item.valueInfo)));
};
ItemContent.propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  noNotificationText: _propTypes["default"].bool
};
var Item = function Item(_ref2) {
  var item = _ref2.item,
    index = _ref2.index,
    isLast = _ref2.isLast,
    noNotificationText = _ref2.noNotificationText;
  return item.onClick ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: /*#__PURE__*/_react["default"].createElement(ItemContent, {
      item: item,
      index: index,
      noNotificationText: noNotificationText
    }),
    buttonType: _constants.BUTTON_TYPES.BARE,
    onClick: item.onClick,
    className: "".concat(item.className, " justify-start"),
    disabled: item.isSelected
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--items__item flex justify-between ".concat(!isLast ? ' margin-bottom-md' : '')
  }, /*#__PURE__*/_react["default"].createElement(ItemContent, {
    item: item,
    index: index,
    noNotificationText: noNotificationText
  }));
};
Item.propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  isLast: _propTypes["default"].bool,
  noNotificationText: _propTypes["default"].bool
};
Item.deafultProps = {
  isLast: false
};
var _default = exports["default"] = Item;